import { Box, Icon, useClassNames } from '@factorialco/deprecated-design-system'

import {
  HeaderCellsHoverContent,
  HeaderCellsHoverFooter,
  HeaderCellsHoverHeader,
} from 'modules/project_management/components/Schedule/Body/ScheduleItem/HeaderRow/HeaderCellsHover'
import * as stylesRefs from 'modules/project_management/components/Schedule/Body/ScheduleItem/index.vanilla.css'
import { HeaderCellType } from 'modules/project_management/components/Schedule/Body/ScheduleItem/types'
import { gridArea } from 'modules/project_management/components/Schedule/Body/ScheduleItem/utils'
import HoverScheduleCard from 'modules/project_management/components/Schedule/HoverScheduleCard'
import ScheduleCellText from 'modules/project_management/components/Schedule/ScheduleCellText'

interface IHeaderCellProps {
  data: HeaderCellType
}

const HeaderCell = ({ data }: IHeaderCellProps) => {
  const cx = useClassNames(stylesRefs)
  const flexDirection = data.columnSpan === 1 ? 'column' : 'row'
  const paddingTopText = data.columnSpan === 1 ? 's0' : 's4'

  return (
    <Box
      className={cx('scheduleItemHeaderCell')}
      style={{
        ...gridArea(data.rowStart, data.columnStart, data.rowSpan, data.columnSpan),
      }}
    >
      {data.plannedMinutes !== 0 && (
        <HoverScheduleCard
          content={<HeaderCellsHoverContent data={data} />}
          footer={<HeaderCellsHoverFooter data={data} />}
          header={<HeaderCellsHoverHeader data={data} />}
        >
          <Box
            className={cx('mergedCellContent')}
            flexDirection={flexDirection}
            flexNoShrink
            background="purple200"
          >
            <Box flexDirection="row" alignItems="flexStart">
              <ScheduleCellText minutes={data.plannedMinutes} short={data.columnSpan === 1} />
            </Box>
            {data.plannedMinutes > data.expectedMinutes && (
              <Icon.Small icon="alert-circle" color="radicalRed1000" />
            )}
            {data.plannedMinutes === data.expectedMinutes && (
              <Icon.Small icon="check" color="grey800" />
            )}
          </Box>
        </HoverScheduleCard>
      )}
    </Box>
  )
}

export default HeaderCell
